import { StatusColor } from '../types';

export const statusType = (property: string, mapping: { [x: string]: string }) => (props: { [x: string]: string }) =>
  mapping[StatusColor[props[property] as keyof typeof StatusColor]];
